(function () {
if (typeof hubspot !== "undefined" && hubspot !== null) {
  if (typeof hubspot.defineEager === "function") {
    hubspot.defineEager('I18n.React', ['I18n', 'React'], (function(_this) {
      return function(I18n, React) {
        var EMPTY_OPTIONS, I18nStringFactory, childrenToArray, getPassThroughProps, i18nCommon, listOptions;
        I18n.React || (I18n.React = {});
        I18nStringFactory = React.createFactory('i18n-string');
        EMPTY_OPTIONS = {};
        i18nCommon = {
          propTypes: {
            message: React.PropTypes.string.isRequired,
            options: React.PropTypes.object,
            useGap: React.PropTypes.bool
          },
          getDefaultProps: function() {
            return {
              options: EMPTY_OPTIONS,
              useGap: false
            };
          },
          _getValue: function() {
            var message, options, ref, useGap, value;
            ref = this.props, useGap = ref.useGap, message = ref.message, options = ref.options;
            value = I18n.text(message, options);
            if (useGap === true) {
              value = " " + value + " ";
            }
            return value;
          }
        };
        getPassThroughProps = function(allProps) {
          var propKey, result;
          result = {
            'data-locale-at-render': I18n.locale,
            'data-key': allProps.message
          };
          for (propKey in allProps) {
            if (propKey !== 'message' && propKey !== 'options' && propKey !== 'useGap') {
              result[propKey] = allProps[propKey];
            }
          }
          return result;
        };
        I18n.React.FormattedHTMLMessage = React.createClass({
          displayName: 'I18n.React.FormattedHTMLMessage',
          mixins: [i18nCommon],
          render: function() {
            var message, props;
            message = this.props.message;
            props = getPassThroughProps(this.props);
            props['dangerouslySetInnerHTML'] = {
              __html: this._getValue()
            };
            return I18nStringFactory(props);
          }
        });
        I18n.React.FormattedReactMessage = React.createClass({
          displayName: 'I18n.React.FormattedReactMessage',
          mixins: [i18nCommon],
          getEscapedParam: function(optName, optValue) {
            if (!React.isValidElement(optValue)) {
              return React.createElement('span', {
                dangerouslySetInnerHTML: {
                  __html: I18n.formatParam(optName, optValue)
                },
                key: optName
              });
            }
            return React.cloneElement(optValue, {
              key: optName,
              ref: optValue.ref
            });
          },
          render: function() {
            var props;
            props = getPassThroughProps(this.props);
            I18nStringFactory(props);
            return React.createElement('span', props, this.renderFormattedMessage());
          },
          renderFormattedMessage: function() {
            return I18n.interpolateToArray(this.props.message, this.props.options, this.getEscapedParam);
          }
        });
        I18n.React.text = function(msg, opts) {
          var key;
          for (key in opts) {
            if (typeof opts[key] === 'string') {
              opts[key] = I18n.SafeString(opts[key]);
            }
          }
          return I18n.text(msg, opts);
        };
        I18n.React.FormattedMessage = React.createClass({
          displayName: 'I18n.React.FormattedMessage',
          mixins: [i18nCommon],
          render: function() {
            var message, props;
            message = this.props.message;
            props = getPassThroughProps(this.props);
            return I18nStringFactory(props, this._getValue());
          }
        });
        childrenToArray = function(children) {
          var result;
          result = [];
          React.Children.forEach(children, function(child) {
            return result.push(child);
          });
          return result;
        };
        listOptions = {
          excessKey: true,
          exclusive: true,
          lastWordConnector: true,
          limit: true,
          locale: true,
          twoWordsConnector: true,
          wordsConnector: true
        };
        I18n.React.FormattedList = React.createClass({
          displayName: 'I18n.React.FormattedList',
          propTypes: {
            className: React.PropTypes.string,
            excessKey: React.PropTypes.string,
            exclusive: React.PropTypes.bool,
            lastWordConnector: React.PropTypes.string,
            limit: React.PropTypes.number,
            locale: React.PropTypes.string,
            twoWordsConnector: React.PropTypes.string,
            wordsConnector: React.PropTypes.string
          },
          getPassThroughProps: function() {
            var passThrough;
            passThrough = {};
            Object.keys(this.props).forEach((function(_this) {
              return function(key) {
                if (!listOptions[key]) {
                  return passThrough[key] = _this.props[key];
                }
              };
            })(this));
            return passThrough;
          },
          render: function() {
            return React.createElement('span', this.getPassThroughProps(), I18n.formatListArray(childrenToArray(this.props.children), this.props));
          }
        });
        return I18n.React;
      };
    })(this));
  }
}

if (typeof hubspot !== "undefined" && hubspot !== null) {
  if (typeof hubspot.define === "function") {
    hubspot.define('I18n.React.FormattedHTMLMessage', ['I18n.React'], function() {
      return I18n.React.FormattedHTMLMessage;
    });
  }
}

if (typeof hubspot !== "undefined" && hubspot !== null) {
  if (typeof hubspot.define === "function") {
    hubspot.define('I18n.React.FormattedReactMessage', ['I18n.React'], function() {
      return I18n.React.FormattedReactMessage;
    });
  }
}

if (typeof hubspot !== "undefined" && hubspot !== null) {
  if (typeof hubspot.define === "function") {
    hubspot.define('I18n.React.text', ['I18n.React'], function() {
      return I18n.React.text;
    });
  }
}

if (typeof hubspot !== "undefined" && hubspot !== null) {
  if (typeof hubspot.define === "function") {
    hubspot.define('I18n.React.FormattedMessage', ['I18n.React'], function() {
      return I18n.React.FormattedMessage;
    });
  }
}

if (typeof hubspot !== "undefined" && hubspot !== null) {
  if (typeof hubspot.define === "function") {
    hubspot.define('I18n.React.FormattedList', ['I18n.React'], function() {
      return I18n.React.FormattedList;
    });
  }
}
}());




//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/node_modules/bender-webpack/lib/legacy-modules/module-manifest-dependency-loader.js!/usr/share/hubspot/build/workspace/MeetingsUI/node_modules/bender-webpack/lib/no-parse-loader.js!/usr/share/hubspot/build/workspace/MeetingsUI/node_modules/@hs/sporks-loader/lib!/usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/coffee/react-helpers.coffee
// module id = 390
// module chunks = 